// --------------------------------------------------------------------------------
// Angular Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// --------------------------------------------------------------------------------
// Materilize CSS Import
import 'materialize-css';

// --------------------------------------------------------------------------------
// All Other Components & Services
import {
    PreloaderComponent, PaginationComponent, MaterializeModule, ChartModule, ChartWidgetContainerComponent, ChartWidgetComponent,
    ChartWidgetContainerService, ChartWidgetService, DataWidgetComponent, DataWidgetContainerComponent, DataWidgetService,
    DataWidgetContainerService, ListWidgetComponent, ListWidgetContainerComponent, ListWidgetContainerService, ListWidgetService,
    NoteWidgetContainerService, NoteWidgetService, NoteWidgetContainerComponent, NoteWidgetComponent, NoteService,
    ActivityWidgetContainerComponent, ActivityWidgetComponent, ActivityWidgetContainerService, ActivityWidgetService, QRCodeGeneratorComponent,
    NonAllocatedSimComponent, NonAllocatedSimService, SheetComponent, ReversePipe, SortTrafficPipe, SheetService, PopulateFormService,
    ReportService, LoadingComponent, LoadingService, AddressComponent, AddressService, AssistantComponent, AuthorizedStatusService, ControlStateRefreshService
        } from './index';
import {
    ReportUnitBackgroundService, ReportCancelledUnitBackgroundService
 } from './tools/index';

// --------------------------------------------------------------------------------
// Unit Create Comonents & Services
import { UnitCreateComponent, UnitCreateService } from './units/index';
import { TrafficModalComponent, TrafficHistoryComponent, TrafficLiveComponent, TrafficHistoryService, TrafficLiveService, TrafficService } from './traffic/index';

// --------------------------------------------------------------------------------
// QR Code Generator Import
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
    exports: [
        MaterializeModule,
        ChartModule,
        PreloaderComponent,
        PaginationComponent,
        LoadingComponent,
        NonAllocatedSimComponent,
        SheetComponent,
        ChartWidgetContainerComponent,
        ChartWidgetComponent,
        DataWidgetContainerComponent,
        DataWidgetComponent,
        ListWidgetContainerComponent,
        ListWidgetComponent,
        NoteWidgetContainerComponent,
        NoteWidgetComponent,
        ActivityWidgetContainerComponent,
        ActivityWidgetComponent,
        AddressComponent,
        ReversePipe,
        SortTrafficPipe,
        AssistantComponent,
        UnitCreateComponent,
        TrafficModalComponent,
        TrafficHistoryComponent,
        TrafficLiveComponent,
        QRCodeGeneratorComponent
    ],
    imports: [
        QRCodeModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterializeModule,
        ChartModule
    ],
    declarations: [
        PreloaderComponent,
        PaginationComponent,
        LoadingComponent,
        NonAllocatedSimComponent,
        SheetComponent,
        ChartWidgetContainerComponent,
        ChartWidgetComponent,
        DataWidgetContainerComponent,
        DataWidgetComponent,
        ListWidgetContainerComponent,
        ListWidgetComponent,
        NoteWidgetContainerComponent,
        NoteWidgetComponent,
        ActivityWidgetContainerComponent,
        ActivityWidgetComponent,
        AddressComponent,
        ReversePipe,
        SortTrafficPipe,
        AssistantComponent,
        UnitCreateComponent,
        TrafficModalComponent,
        TrafficHistoryComponent,
        TrafficLiveComponent,
        QRCodeGeneratorComponent
    ],
    providers: [
        AddressService,
        ChartWidgetContainerService,
        ChartWidgetService,
        DataWidgetContainerService,
        DataWidgetService,
        ListWidgetContainerService,
        ListWidgetService,
        NoteWidgetContainerService,
        NoteWidgetService,
        ActivityWidgetContainerService,
        ActivityWidgetService,
        NonAllocatedSimService,
        NoteService,
        SheetService,
        PopulateFormService,
        ReportService,
        LoadingService,
        ReportUnitBackgroundService,
        ReportCancelledUnitBackgroundService,
        UnitCreateService,
        AuthorizedStatusService,
        TrafficHistoryService,
        TrafficLiveService,
        TrafficService,
        ControlStateRefreshService
    ]
})

export class SharedModule {}


// WEBPACK FOOTER //
// ./angularApp/app/shared.module.ts